import styles from './DocumentCard.module.css';
import cn from 'classnames';

export interface DocumentsData {
  type: string;
  date: string;
  title: string;
  file: string;
}

export default function DocumentCard({ type, date, title, file }: DocumentsData) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.info_wrapper}>
        <p className={cn('text_body_b3', styles.date)}>{date}</p>
        <p className='text_subheaders_sh2'>{title}</p>
      </div>
      <a
        className={cn('text_subheaders_sh2', styles.button)}
        href={file}
        download={title}
        target="_blank"
        rel="noopener noreferrer"
      >
        Скачать
      </a>
    </div>
  );
}